export default "__VITE_ASSET__D3roT2T$__"